import { OutboundMessageStatus } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/enums.pb';
import { Sort_Enum } from '@weave/schema-gen-ts/dist/schemas/sms/draft/v1/draft_service.pb';

export enum InboxStatus {
  UNREAD = 'new',
  UNREPLIED = 'unreplied',
  READ = 'read',
  REPLIED = 'replied',
  ERROR = 'error',
}

export enum InboxTabType {
  ACTIONABLE = 'actionable',
  ALL = 'all',
}
export type InboxTabTypes = InboxTabType;

export enum InboxTaskStatus {
  TODO = 'todo',
  IN_PROGRESS = 'in_progress',
}

export enum ConversationTypeFilter {
  INDIVIDUAL = 'individual',
  GROUP = 'group',
}

export enum AIReceptionistFilterStatus {
  IS_ACTIVE = 'isActive',
  IS_INACTIVE = 'isInactive',
  NEEDS_ATTENTION = 'needsAttention',
  ADDED_TO_SCHEDULE = 'addedToSchedule',
  APPOINTMENT_REQUESTED = 'appointmentRequested',
  CANCELED = 'canceled',
  COMPLETE = 'complete',
}

export type InboxFilters = {
  statuses: InboxStatus[];
  tags: string[];
  locationPhones: string[];
  tasks: InboxTaskStatus[];
  aiReceptionist: AIReceptionistFilterStatus[];
  // Single-value filter (empty string means unselected), aligned with date/time field patterns.
  conversationType: ConversationTypeFilter | '';
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
};
export type InboxFilter = keyof InboxFilters;
export type InboxArrayFilters = 'tags' | 'locationPhones' | 'tasks' | 'aiReceptionist';

export type HiddenFilterKeys = (InboxFilter | 'date' | 'time')[] | undefined;

export type ScheduledFilters = {
  statuses: OutboundMessageStatus[];
  tags: string[];
  departments: string[];
};
export type ScheduledFilter = keyof ScheduledFilters;

export type DraftsFilters = {
  [key: string]: unknown; // Once we have the filters, we can add the type here
};
export type DraftsStoreValueType = {
  sort: Sort_Enum;
  filters: DraftsFilters;
};

export type ScheduledConfigs = {
  isPausable: boolean;
};
